var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserExperience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e99dcc81-701f-4e12-8c0c-3c74f3c0965c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .bd2fa084-a481-4d9b-8e14-9eed75310ed6 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "bd2fa084-a481-4d9b-8e14-9eed75310ed6",
    d: "M48.5,37.492A7.641,7.641,0,1,1,57.492,28.5l3.1.477A10.641,10.641,0,1,0,48.976,40.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd2fa084-a481-4d9b-8e14-9eed75310ed6",
    d: "M49.781,45.818A15.825,15.825,0,1,1,65.818,29.781l3,.462c0-.082.013-.161.013-.243A18.83,18.83,0,1,0,50,48.83c.082,0,.162-.012.243-.013Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "bd2fa084-a481-4d9b-8e14-9eed75310ed6",
    points: "68.662 32.875 50 30 52.875 48.662 58.717 42.82 64.543 48.646 68.646 44.542 62.82 38.717 68.662 32.875"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserExperience);
export default __webpack_public_path__ + "static/media/UserExperience.017620dbba2d153a1f8b99cc4eefe43a.svg";
export { ForwardRef as ReactComponent };